import { render } from "./ShareView.vue?vue&type=template&id=f9b18e7c&scoped=true"
import script from "./ShareView.vue?vue&type=script&lang=js"
export * from "./ShareView.vue?vue&type=script&lang=js"

import "./ShareView.vue?vue&type=style&index=0&id=f9b18e7c&lang=css"
import "./ShareView.vue?vue&type=style&index=1&id=f9b18e7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9b18e7c"]])

export default __exports__